import apiHosts from '../ApiHosts.json'

const getBaseUrl = () => {
  const params = new URLSearchParams(window.location.search)
  const backendKey = params.get('_be')
  return (backendKey && apiHosts[backendKey]) || apiHosts.local
}

export const getApiUrls = (accountId, powerformId) => {
  const baseUrl = getBaseUrl()
  return {
    dssUrl: `${baseUrl}api/accounts/${accountId}/powerforms/${powerformId}/dss`,
    signingUrl: `${baseUrl}api/accounts/${accountId}/powerforms/${powerformId}/signing`,
    logUrl: `${baseUrl}log`,
    configUrl: `${baseUrl}config`,
  }
}
